class TextInputValidator {
  constructor(maxLength, allowedCharacters, prohibitedCharacters) {
    this.maxLength = maxLength;
    this.allowedCharacters = allowedCharacters;
    this.prohibitedCharacters = prohibitedCharacters;

    this._allowedSet = allowedCharacters && allowedCharacters.length > 0
      ? new Set(allowedCharacters)
      : null;
    this._prohibitedSet = prohibitedCharacters && prohibitedCharacters.length > 0
      ? new Set(prohibitedCharacters)
      : null;
  }

  validate(value) {
    let result = String(value || '');
    result = this.applyMaxLength(result);
    result = this.removeProhibitedCharacters(result);
    result = this.keepOnlyAllowedCharacters(result);
    return result;
  }

  isValid(value) {
    return value === this.validate(value);
  }

  applyMaxLength(value) {
    if (this.maxLength > 0 && value.length > this.maxLength) {
      return value.substring(0, this.maxLength);
    }
    return value;
  }

  removeProhibitedCharacters(value) {
    if (!this._prohibitedSet) return value;
    return value.split('').filter((char) => !this._prohibitedSet.has(char)).join('');
  }

  keepOnlyAllowedCharacters(value) {
    if (!this._allowedSet) return value;
    return value.split('').filter((char) => this._allowedSet.has(char)).join('');
  }
}

export default TextInputValidator;

